import { createGlobalStyle, css } from 'styled-components';

import { MenuWidth, MenuWidthCollapsed } from 'components/Menu/styles';

import { YogaTheme } from 'types/others';

export const GlobalStyle = createGlobalStyle<{ color: string }>`
  html {
    box-sizing: border-box;
    font-size: 16px;
  }

  *, *:before, *:after {
    box-sizing: inherit;
    color: ${({ color }) => color};
    font-family: Rubik, sans-serif;
  }

  body, h1, h2, h3, h4, h5, h6, p, ol, ul {
    margin: 0;
    padding: 0;
    font-weight: normal;
  }

  ol, ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  h1, h2, h3, h4, h5, h6, p, ol, ul {
    white-space: pre-wrap;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  a {
    text-decoration: none;
  }

  div.ReactModal__Overlay--after-open {
      margin-left: 0;

      @media (min-width: 1024px) {
          margin-left: ${MenuWidthCollapsed};
      }
      

      @media (min-width: 1440px) {
          margin-left: ${MenuWidth};
      }
  }
`;

export const gradeColourBackground = css<{
  theme: YogaTheme;
  grade?: string;
}>`
  background-color: ${({ theme, grade }) => {
    if (grade === 'low') {
      return theme.yoga.colors.grade.low;
    }
    if (grade === 'medium') {
      return theme.yoga.colors.grade.medium;
    }
    if (grade === 'high') {
      return theme.yoga.colors.grade.high;
    }
    return 'transparent';
  }};
`;
